import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Table } from 'reactstrap';
import { useIntl } from 'react-intl';

import { APIgetPageDetails } from '../../../../api/Pages';

import { handleComponentParams } from '../../../../helpers/URLParams';
import { downloadCSV } from '../../../../helpers/App';

import Loading from '../../../Loading';
import ProcessingSpinner from '../../../ProcessingSpinner';
import CollectedDetailsListHeader from './CollectedDetailsListHeader';
import CollectedDetailsListItem from './CollectedDetailsListItem';
import CollectedDetailsFooter from './CollectedDetailsFooter';

const CollectedDetails = ({ pageId }) => {
  const intl = useIntl();

  const [loading, setLoading] = useState(true);
  const [downloading, setDownloading] = useState(false);
  const [history, setHistory] = useState([]);
  const [meta, setMeta] = useState(null);
  const [page, setPage] = useState(1);
  const [perPage] = useState(20);

  useEffect(() => {
    handleComponentParams(
      true,
      ['page'],
      null,
      [setPage],
      () => {},
    );
  }, []);

  useEffect(() => {
    setLoading(true);
    APIgetPageDetails(pageId, { page, per_page: perPage }).then((response) => {
      setHistory(response.data.data);
      setMeta(response.data.meta);
      setLoading(false);
    });
  }, [page, perPage, pageId]);

  const handleDownloadCSV = () => {
    setDownloading(true);
    APIgetPageDetails(pageId, { csv: true }).then((response) => {
      const disposition = response.headers['content-disposition'] || '';
      const match = /filename\*\s*=\s*UTF-8''([^;]+)|filename\s*=\s*"?([^";]+)"?/i.exec(disposition);
      const fileName = match
        ? decodeURIComponent((match[1] || match[2]).trim())
        : 'content-portal-details.csv';

      return downloadCSV(response.data, fileName);
    }).finally(() => {
      setDownloading(false);
    });
  };

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  if (loading) {
    return (
      <div className="tab-content-wrapper">
        <Loading className="gray" />
      </div>
    );
  }

  return (
    <div className="tab-content-wrapper">
      <div className="collected-details-wrapper">
        <div>
          <h4>
            {intl.formatMessage({ defaultMessage: 'Collected names and emails' })}
          </h4>
          <p>
            {intl.formatMessage({ defaultMessage: 'Browse names and emails collected on this Content Portal' })}
          </p>
        </div>
        <div>
          <Button
            disabled={downloading}
            onClick={handleDownloadCSV}
          >
            <ProcessingSpinner show={downloading} />
            {intl.formatMessage({ defaultMessage: 'Download CSV' })}
          </Button>
        </div>
      </div>
      <div>
        {history && history.length > 0 ? (
          <>
            <div className="table-wrapper">
              <Table className="files-list collected-details-list" responsive>
                <thead>
                  <CollectedDetailsListHeader
                    downloading={downloading}
                    handleDownloadCSV={handleDownloadCSV}
                  />
                </thead>
                <tbody>
                  {history.map(element => (
                    <CollectedDetailsListItem
                      key={element.uuid}
                      element={element}
                    />
                  ))}
                </tbody>
              </Table>
            </div>
            <CollectedDetailsFooter
              total={meta ? meta.total : 0}
              page={page}
              perPage={perPage}
              handleChangePage={handleChangePage}
            />
          </>
        ) : (
          <div className="nothing-found-wrapper bottom">
            <h3>{intl.formatMessage({ defaultMessage: 'No collected details' })}</h3>
          </div>
        )}
      </div>
    </div>
  );
};

CollectedDetails.propTypes = {
  pageId: PropTypes.string.isRequired,
};

export default CollectedDetails;
